module.exports = __webpack_public_path__ + "img/laos.42c47053.png";